import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=ec75505e"
import script from "./Live.vue?vue&type=script&lang=ts"
export * from "./Live.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports